<div class="modal-content">
    <div class="modal-header">
        <h3 class="modal-title pull-left" aria-hidden="true" id="my-modal-title">{{'MEDICAL_APL_POPUP_TEXT_01' | globalTranslate}}</h3>
        <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
            <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon"/>
        </button>
    </div>
    <div class="modal-body">
        <p [innerHTML]="'MEDICAL_APL_POPUP_TEXT_02' | globalTranslate"></p>
    </div>    
    <div class="modal-footer action-container" >
        <div class="me-2 ml-2">
          <button type="button" id="dialog1" class="btn d-grid align-items-center btn-secondary" [ngClass]="{'lang-sp': translatedLang === 'sp'}" (click)="fileEliigibilityAppeal('APL')">{{
            'MEDICAL_APL_BTN_TEXT_01' | globalTranslate }}</button>
        </div>
        <div class="me-2 ml-2">
          <button type="button" id="dialog1" class="btn d-grid align-items-center btn-link" [ngClass]="{'lang-sp': translatedLang === 'sp'}" (click)="onCancel()">{{ 'MEDICAL_APL_BTN_TEXT_02' | globalTranslate
            }}</button>
        </div>
      </div>
</div>
